import { showCustomToast } from "@/shared/components/generic/snackbar/showCustomToast.tsx";
import IconRoundedExclamationMark from "@/shared/components/generic/icons/IconRoundedExclamationMark.tsx";

export default function showErrorToast(message: string): void {
  showCustomToast({
    message,
    style: "ERROR",
    icon: IconRoundedExclamationMark,
    showCloseIcon: true,
  });
}
